import React from "react";
import { useEffect } from "react";
import PencarianBT from "../../components/Pinjam/PencarianBT";

const Pencarian = () => {
  useEffect(() => {
    document.title = "Si TASIK - Pencarian";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <PencarianBT/>
    </div>
  );
};

export default Pencarian;
